/**
 * Inductor — three half-circle humps. Reads as an air-core inductor at
 * any zoom; iron-core variant (parallel lines above the humps) deferred
 * until `Component` exposes a magnetics flag.
 */
import { useTheme } from "@mui/material";
import type { NodeProps } from "@xyflow/react";

import { SymbolFrame } from "./SymbolFrame";
import { SYMBOL_STROKE_WIDTH, symbolColors } from "./symbolStyle";

interface InductorData {
  refdes?: string;
  value?: string | null;
  highlight?: boolean;
}

export function InductorNode({ data, width, height }: NodeProps) {
  const t = useTheme();
  const { stroke } = symbolColors(t);
  const d = data as InductorData;
  return (
    <SymbolFrame
      refdes={d.refdes}
      value={d.value}
      width={width}
      height={height}
      highlight={d.highlight}
    >
      <svg
        viewBox="0 0 64 20"
        width="64"
        height="18"
        fill="none"
        stroke={stroke}
        strokeWidth={SYMBOL_STROKE_WIDTH}
        strokeLinecap="round"
      >
        <line x1="0" y1="14" x2="8" y2="14" />
        <path d="M8,14 A6,6 0 0,1 20,14" />
        <path d="M20,14 A6,6 0 0,1 32,14" />
        <path d="M32,14 A6,6 0 0,1 44,14" />
        <path d="M44,14 A6,6 0 0,1 56,14" />
        <line x1="56" y1="14" x2="64" y2="14" />
      </svg>
    </SymbolFrame>
  );
}
